module.exports = __webpack_public_path__ + "static/media/ar4.d0ffaf9e.jpg";